export const serviceTypesValidator = type => {
  return ["call", "package", "fax", "sms"].indexOf(type); // fixme use here string name in constants: @/constants/serviceTypes.js
};
export const transactionTypeValidator = type => {
  return ["incoming", "outgoing"].indexOf(type); // fixme use here string name in constants: @/constants/transactionTypes.js
};
